import { handleActions } from 'redux-actions';
import * as templatesActions from '../actions/templatesActions';

let templatesState = {
  templateData: null,
  allTemplates: null,
  templatesLoading: false,
  errorMessage: '',
};

export const templates = handleActions(
  {
    [templatesActions.getAllTemplates]: state => {
      return { ...state, templatesLoading: true };
    },
    [templatesActions.getAllTemplatesSuccess]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        allTemplates: payload,
        templatesLoading: false,
      };
    },
    [templatesActions.getAllTemplatesFailure]: (state, action) => {
      let { payload } = action;
      return {
        ...state,
        errorMessage: payload,
        templatesLoading: false,
      };
    },
  },
  templatesState
);
